import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import agentsReducer from 'containers/Agents/reducer'
import agentsDashboardReducer from 'containers/AgentsDashboard/reducer'
import alertsReducer from 'containers/Alerts/reducer'
import appReducer from 'containers/App/reducer'
import eulaModalReducer from 'containers/EULAModal/reducer'
import firstLoginModalReducer from 'containers/FirstLoginModal/reducer'
import globalBannerReducer from 'containers/GlobalBanner/reducer'
import accountSetupReducer from 'containers/Navigation/AccountSetup/reducer'
import onboardingWizardReducer from 'containers/OnboardingWizard/onboardingWizardReducer'
import partnerOptionsReducer from 'containers/PartnerOptions/reducer'
import pollingReducer from 'containers/Polling/reducer'
import scenarioFormReducer from 'containers/ScenarioForm/reducer'
import scenarioPreviewReducer from 'containers/ScenarioPreview/reducer'
import { connectWiseReducer } from 'containers/Settings/MalwareDetection/ConnectWise'
import { psaWizardReducer } from 'containers/Settings/MalwareDetection/PSA'
import shareReducer from 'containers/Share/reducer'
import shareReportReducer from 'containers/ShareReport/reducer'
import spearPhishingAgentReducer from 'containers/SpearPhishingAgent/spearPhishingAgentReducer'
import toastsReducer from 'containers/Toasts/reducer'
import upgradeLicenseModalReducer from 'containers/UpgradeLicenseModal/reducer'

/**
 * Consider adding reducer as a dependency of
 * a specific component in components/RootComponent.js
 * file to avoid permanent reducer presence if no need.
 */
export default function createReducer(asyncReducers) {
  return combineReducers({
    agents: agentsReducer,
    agentsDashboard: agentsDashboardReducer,
    alerts: alertsReducer,
    app: appReducer,
    form: formReducer,
    toasts: toastsReducer,
    accountSetup: accountSetupReducer,
    share: shareReducer,
    shareReport: shareReportReducer,
    partnerOptions: partnerOptionsReducer,
    polling: pollingReducer,
    globalBanner: globalBannerReducer,
    upgradeLicenseModal: upgradeLicenseModalReducer,
    firstLoginModal: firstLoginModalReducer,
    eulaModal: eulaModalReducer,
    scenarioForm: scenarioFormReducer,
    scenarioPreview: scenarioPreviewReducer,
    connectWise: connectWiseReducer,
    psaWizard: psaWizardReducer,
    onboardingWizard: onboardingWizardReducer,
    spearPhishingAgent: spearPhishingAgentReducer,
    ...asyncReducers,
  })
}
